const NotificationGroupEnum = Object.freeze({
    GENERAL: 'GENERAL',
    INVESTOR: 'INVESTOR',
    ADVISER: 'ADVISER',
    PRIMARY_CONTACT: 'PRIMARY_CONTACT',
    PROVIDER: 'PROVIDER',
    FUND_MANAGER: 'FUND_MANAGER',
    COMPANY: 'COMPANY'
});

export default NotificationGroupEnum;
